"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestAllExcelDownloadUrlToJSONTyped = exports.RequestAllExcelDownloadUrlToJSON = exports.RequestAllExcelDownloadUrlFromJSONTyped = exports.RequestAllExcelDownloadUrlFromJSON = exports.instanceOfRequestAllExcelDownloadUrl = void 0;
/**
 * Check if a given object implements the RequestAllExcelDownloadUrl interface.
 */
function instanceOfRequestAllExcelDownloadUrl(value) {
    if (!('stations' in value) || value['stations'] === undefined)
        return false;
    return true;
}
exports.instanceOfRequestAllExcelDownloadUrl = instanceOfRequestAllExcelDownloadUrl;
function RequestAllExcelDownloadUrlFromJSON(json) {
    return RequestAllExcelDownloadUrlFromJSONTyped(json, false);
}
exports.RequestAllExcelDownloadUrlFromJSON = RequestAllExcelDownloadUrlFromJSON;
function RequestAllExcelDownloadUrlFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'stations': json['stations'],
        'part': json['part'] == null ? undefined : json['part'],
    };
}
exports.RequestAllExcelDownloadUrlFromJSONTyped = RequestAllExcelDownloadUrlFromJSONTyped;
function RequestAllExcelDownloadUrlToJSON(json) {
    return RequestAllExcelDownloadUrlToJSONTyped(json, false);
}
exports.RequestAllExcelDownloadUrlToJSON = RequestAllExcelDownloadUrlToJSON;
function RequestAllExcelDownloadUrlToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'stations': value['stations'],
        'part': value['part'],
    };
}
exports.RequestAllExcelDownloadUrlToJSONTyped = RequestAllExcelDownloadUrlToJSONTyped;
